module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/how-works-mobile.a9005861.svg";